const SubjectCard = () => {
	return (
		<div className="h-36 w-100 radius bg-white hover:bg-slate-50 cursor-pointer transition-all ease-in delay-100 flex flex-col items-start pl-5 justify-center text-slate-900 relative shadow-lg border shadow-slate-100">
			<h3 className="font-semibold">Bac 2022</h3>
			<h6>
				<span className="font-medium">Sujet de:</span>{" "}
				<span className="font-normal"> physique</span>
			</h6>
			<h6>
				<span className="font-medium">Option:</span>{" "}
				<span className="font-normal"> Mathématique</span>
			</h6>
			<button className="bg-orange-500 text-white p-1 text-sm font-medium mt-2 rounded-tr-lg rounded-bl-lg transition-all duration-300 ease-in hover:shadow-lg">
				Télécharger
			</button>
		</div>
	);
};

export default SubjectCard;
